import { useUI } from "providers/UIProvider"
import { getColumns } from "./columns"
import Table from "components/UI/organisms/Table"
import { getActions } from "./actions"
import { getInsideActions } from "./insideActions"
import ClientBookingsModal from "components/shared/modals/ClientReservationsModal"
import ClientAutosModal from "components/shared/modals/ClientAutosModal"
import ClientTransactionsModal from "components/shared/modals/ClientTransactionsModal"
import { useCustomersContext } from "providers/CustomersProvider/CustomersProvider"
import { ICustomer } from "types/customer"

import BdsLogo from "assets/img/bds-logo.png"
import { Text, Image, Flex } from "@chakra-ui/react"

const CustomersTable = () => {
  const { T, toggleModal, modals } = useUI()

  const { customers, customersDataLoading, handleCustomersPaginationClick, query, handleBlockUnblockClick, handleDeleteClick, handleReservationsClick, handleAutosClick, handleTransactionsClick } = useCustomersContext()

  const clientReservationsClick = (customer: ICustomer) => {
    toggleModal("clientReservationsModal", true)
    handleReservationsClick(customer)
  }

  const clientAutosClick = (customer: ICustomer) => {
    toggleModal("clientAutosModal", true)
    handleAutosClick(customer)
  }

  const clientTransactionsClick = (customer: ICustomer) => {
    toggleModal("clientTransactionsModal", true)
    handleTransactionsClick(customer)
  }

  const columns = getColumns(T)
  const tableActions = getActions({ T, handleBlockUnblockClick, handleDeleteClick })

  const insideActions = getInsideActions({ T, clientReservationsClick, clientAutosClick, clientTransactionsClick })

  return (
    <>
      {modals.clientReservationsModal && (<ClientBookingsModal />)}
      {modals.clientAutosModal && (<ClientAutosModal />)}
      {modals.clientTransactionsModal && (<ClientTransactionsModal />)}
      <Table
        topBorderRadius={false}
        data={customers.data}
        columns={columns}
        loading={customersDataLoading}
        insideActions={insideActions}
        actions={tableActions}
        extraHeaderCols={2}
        pagination={{
          total: customers.itemCount,
          perPage: Number(query.pageSize),
          currentPage: Number(query.pageIndex),
          onClick: handleCustomersPaginationClick
        }}
      />
      <Flex style={{ flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "5px", height: "2rem" }}>
        <Text style={{
          opacity: "50%",
          fontSize: "11px",
          whiteSpace: "nowrap",
        }}>
          {"Powered by"}
        </Text>
        <a target='_blank'
          rel='noopener noreferrer' href="https://bds.ge">
          <Image alt="BDS Logo" src={BdsLogo} height="14px" />
        </a>
      </Flex>
    </>
  )
}

export default CustomersTable
